module.exports = __webpack_public_path__ + "img/sy02.16910a2a.svg";